

<!-- @format -->
<script lang="ts">
  import { slide } from "svelte/transition";
  import { createEventDispatcher } from "svelte";
  import { getStoresContext } from "~/stores";
  import type { StoresKey } from "~/stores";
  import { type DayOfTheWeek, dayOfTheWeek } from "~/util/date-n-time";
 
  export let request_store_key: StoresKey;
  export let weekdays: readonly DayOfTheWeek[] = [];

  const { T } = getStoresContext(request_store_key);
  const dispatch = createEventDispatcher();

  let selected = dayOfTheWeek();
  let show_select = false;

  $: selected_day_name = weekdays.find(({ day }) => day == selected)?.name || '';

  function changeDay(day: number) {
    selected = day;
    show_select = false;
    dispatch("changeActiveDay", selected);
  }

  function toggleSelect () {
    show_select = !show_select;
  }

</script>

<div class="day-tabs d-flex" role="tabpanel">
  {#each weekdays as { day, name }}
    <button role="tab"
      class="col d-none d-lg-block"
      class:active={selected == day}
      aria-selected={day == selected}
      on:click={() => changeDay(day)}>
      {name}
    </button>
  {/each}
</div>

<div class="d-lg-none position-relative select-mobile" role="listbox">
  <div class="px-3 py-2 dropdown"
    on:click={toggleSelect}
    on:keyup={toggleSelect}
  >
    <span>{$T`day`}: {selected_day_name}</span>
    <img
      src="/theme/citycon2023/images/down-arrow.png"
      alt="arrow-down"
      width="32" />
  </div>

  {#if show_select}
    <div class="w-100 position-absolute"
      style="z-index: 1;"
      transition:slide|local
      role="list">
      {#each weekdays as { day, name }}
        <button class="option"
          role="option"
          aria-selected={day == selected}
          on:click={() => changeDay(day)}>
          {name}
        </button>
      {/each}
    </div>
  {/if}
</div>

<style lang="scss">

  .day-tabs button {
    background: transparent;
    border: none;
    border-bottom: 1px solid var(--color-black);
    
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    padding: 0.6rem 0;

    @media screen and (min-width: 1280px) {
      font-size: 20px;
    }

    &.active, &:hover {
      background-color: var(--color-black);
      color: var(--color-white);
    }
  }

  .dropdown {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .select-mobile {
    background-color: #000;
    color: #fff;
    display: block;
    width: 100%;
  }

  .option {
    display: block;
    background-color: var(--color-black);
    width: 100%;
    border: none;
    padding: 0.25rem 0.5rem;
    text-align: left;
    font-size: 18px;
    color: var(--color-white);
  }
  .option:hover {
    background-color: var(--color-white);
    color: var(--color-black);
  }
</style>
